
import React, { useState } from 'react';
import { Divider } from 'primereact/divider';
import AppCard from '../../../components/ui/AppCard';
import InfoField from '../../../components/ui/InfoField';
import { useMountEffect } from 'primereact/hooks';
import apiClient from "../../../services/api-client";
import { Skeleton } from 'primereact/skeleton';
import paymentImage from "../../../assets/images/patterns/loans-bg.png"
import { Accordion, AccordionTab } from 'primereact/accordion';
import StorageHelper from '../../../utils/storage-helper';
// import '../../../assets/styles/auth-tokens.css';
// import '../../../assets/styles/dashboard-theme.css';

const getStatusTone = (statusValue) => {
    if (!statusValue) return "warning";
    const value = statusValue.toLowerCase();
    if (value.includes("active") || value.includes("approved") || value.includes("obligations met") || value.includes("paid")) return "success";
    if (value.includes("reject") || value.includes("written off") || value.includes("withdraw") || value.includes("overdue")) return "danger";
    return "warning";
};

export default function TrackLoanApplication() {

    const [loanDetails, setLoanDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    let userProfile = {};

    useMountEffect(() => {
        getPolicyDetails();
    }, []);

    const getPolicyDetails = async () => {
        setLoading(true)
        try {
            userProfile = (StorageHelper.get('userProfile'));

            await apiClient.get('musoni/loans/' + userProfile.idnumber,
                {
                    headers: {
                        Authorization: 'Bearer ' + (StorageHelper.get('token'))
                    }
                }).then((response) => {
                    setLoading(false)
                    if (response.data.status === "SUCCESS" && response.data.responseBody != null) {
                        //console.log("\n\n\n INFORMATION RETURNED")
                        //console.log(response.data?.responseBody)
                        setLoanDetails(response.data?.responseBody?.loans);
                    } else {

                        //console.log(response.data.status)
                    }
                });

        } catch (error) {
            setLoading(false)
            console.error('Error fetching balance details:', error);
        }
    };

    const formatTitle = (inputString) => {
        if (typeof inputString !== 'string') {
            console.error('Input is not a string');
            return '';
        }

        // Split the input string by capital letters
        const words = inputString.split(/(?=[A-Z])/);

        // Capitalize the first letter of each word and join with spaces
        const formattedString = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

        return formattedString;
    };

    return (
        <div className="flex flex-col h-full w-full">
            <div className="w-full">
                <div className="w-full">
                    {loading ? (
                        <div className="border-round border-1 surface-border p-4 surface-card">
                            <div className="flex mb-3">
                                <Skeleton shape="circle" size="4rem" className="mr-2"></Skeleton>
                                <div>
                                    <Skeleton width="10rem" className="mb-2"></Skeleton>
                                    <Skeleton width="5rem" className="mb-2"></Skeleton>
                                    <Skeleton height=".5rem"></Skeleton>
                                </div>
                            </div>
                            <Skeleton width="100%" height="150px"></Skeleton>
                            <div className="flex justify-content-between mt-3">
                                <Skeleton width="4rem" height="2rem"></Skeleton>
                                <Skeleton width="4rem" height="2rem"></Skeleton>
                            </div>
                        </div>) :
                        <>

                            {(loanDetails && loanDetails !== null && loanDetails !== "null" && loanDetails.length !== 0)
                                ? (<> <div className="col-xxl-12 col-xl-12 col-lg-12">
                                    <><AppCard headerImg={paymentImage} className="mb-5 mt-3 w-full">
                                        <div className="invite-content">
                                            {(loanDetails && loanDetails !== null && loanDetails !== "null" && loanDetails.length !== 0) &&
                                                <>
                                                    {Object.keys(loanDetails).map((key, count) => (
                                                        <div key={count}>
                                                            <div className="mb-4">
                                                                <span className="badge badge-info bg-blue-100 text-blue-700 border-none badge-sm uppercase font-bold mb-3 px-3 py-3 rounded-full tracking-wider text-xs">Loans</span>
                                                                <h2 className="text-2xl font-extrabold text-base-content mb-2 tracking-tight">Your {formatTitle(key)}</h2>
                                                                <p className="text-sm text-base-content/70">Track the status and balance of your loan applications.</p>
                                                            </div>
                                                            <Divider type="solid" className="opacity-30 my-4" />

                                                            <Accordion activeIndex={0}>
                                                                {Object.values(loanDetails[key]).map((record, indexNo) => (

                                                                    <AccordionTab active header={"Loan " + (indexNo + 1)} key={indexNo}>

                                                                        <div className="w-full">
                                                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                                                                                <InfoField label="Loan Product Name" value={record.productName} />
                                                                                <div className="dl-info-item">
                                                                                    <span>Loan Status</span>
                                                                                    <strong className={`dl-status-pill dl-status-pill--${getStatusTone(record.status?.value)}`}>
                                                                                        {record.status.value}
                                                                                    </strong>
                                                                                </div>
                                                                                <InfoField label="Currency" value={record.currency.displayLabel} />
                                                                                {record.originalLoan &&
                                                                                    <InfoField label="Original Loan Amount" value={record.currency.displaySymbol + record.originalLoan} />
                                                                                }
                                                                                {record.loanBalance &&
                                                                                    <InfoField label="Loan Balance" value={record.currency.displaySymbol + record.loanBalance} />
                                                                                }
                                                                                {record.amountPaid &&
                                                                                    <InfoField label="Amount Paid" value={record.currency.displaySymbol + record.amountPaid} />
                                                                                }
                                                                                <InfoField label="Loan Type" value={record.loanType.value} />
                                                                                {record.loanCycle &&
                                                                                    <InfoField label="Loan Tenure" value={record.loanCycle + " month(s)"} />
                                                                                }
                                                                                <div className="dl-info-item">
                                                                                    <span>Submitted On</span>
                                                                                    <strong>{
                                                                                        record.timeline.submittedOnDate[2] + "/" +
                                                                                        record.timeline.submittedOnDate[1] + "/" +
                                                                                        record.timeline.submittedOnDate[0]
                                                                                    }</strong>
                                                                                </div>
                                                                                <div className="dl-info-item">
                                                                                    <span>Expected Maturity Date</span>
                                                                                    <strong>{
                                                                                        record?.timeline?.expectedMaturityDate[2] + "/" +
                                                                                        record?.timeline?.expectedMaturityDate[1] + "/" +
                                                                                        record?.timeline?.expectedMaturityDate[0]
                                                                                    }</strong>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </AccordionTab>


                                                                ))}
                                                            </Accordion>
                                                        </div>
                                                    ))}
                                                </>
                                            }
                                        </div>
                                    </AppCard>

                                    </>

                                </div></>)
                                : <></>
                            }

                        </>
                    }
                </div>
            </div>
        </div>
    )
}
